import React from 'react';
import {Grid, Icon, Inputs, Typography} from 'components';

import {makeStyles} from '@material-ui/styles';
import {Box, useMediaQuery} from '@material-ui/core';
import theme from 'theme';

const useStyles = makeStyles((theme) => ({
    wrapper: {
        border: `solid 1px ${theme.palette.blue}`
    },
    header: {
        background: theme.palette.blue,
        display: 'flex',
        alignItems: 'center',
        minHeight: 45,
        padding: theme.spacing(0, 2)
    },
    content: {
        margin: 'auto',
        maxWidth: 700,
        padding: theme.spacing(2)
    }
}));

function StepProfile() {
    const classes = useStyles();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <>
            <Box
                className={'flex'}
                mb={3}
            >
                <Box
                    pl={1}
                    pr={3}
                >
                    <Icon
                        name="axa-icons-help-o"
                        size={50}
                        color="blue"
                    />
                </Box>
                <Box>
                    <Typography
                        variant="h5"
                        color="blue"
                    >
                        J'autorise AXA France Vie à effectuer toutes les démarches nécessaires auprès de l'assureur
                        concerné pour la prise en charge de ce transfert.
                        <br />
                        <br />
                        Je demande à AXA France Vie de répartir cette épargne selon les modalités de gestion des
                        cotisations obligatoires de mon contrat. Je pourrai modifier ma gestion financière sur{' '}
                        <span style={{fontSize: 'inherit', whiteSpace: 'nowrap'}}>axa-mon-epargne-entreprise.com</span>,
                        si je le souhaite.
                    </Typography>
                </Box>
            </Box>

            <Box pl={isMobile ? 0 : 9}>
                <div className={classes.wrapper}>
                    <div className={classes.header}>
                        <Typography
                            variant="h4"
                            color="white"
                            caps
                            semibold
                            gutterBottom={false}
                        >
                            1. Mes coordonnées
                        </Typography>
                    </div>

                    <div className={classes.content}>
                        <Grid
                            container
                            spacing={2}
                        >
                            <Grid item>
                                <Inputs.Text
                                    name="last_name"
                                    label="Nom de naissance *"
                                />
                            </Grid>
                            <Grid item>
                                <Inputs.Text
                                    name="first_name"
                                    label="Prénom *"
                                />
                            </Grid>
                        </Grid>
                        <Inputs.Text
                            name="street_line"
                            label="Adresse *"
                            disableCleave
                        />
                        <Grid
                            container
                            spacing={1}
                        >
                            <Grid
                                item
                                sm={4}
                                xs={12}
                            >
                                <Inputs.Text
                                    name="zip_postal_code"
                                    label="Code postal *"
                                    options={{
                                        blocks: [2, 3]
                                    }}
                                />
                            </Grid>
                            <Grid
                                item
                                sm={8}
                                xs={12}
                            >
                                <Inputs.Text
                                    name="locality"
                                    label="Ville *"
                                />
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            spacing={2}
                        >
                            <Grid
                                item
                                sm={3}
                                xs={12}
                            >
                                <Inputs.Number
                                    name="mobile"
                                    format="phone"
                                    label="N° de téléphone *"
                                />
                            </Grid>
                            <Grid
                                item
                                sm={9}
                                xs={12}
                            >
                                <Inputs.Text
                                    name="email"
                                    label="E-mail *"
                                    disableCleave
                                />
                            </Grid>
                        </Grid>
                    </div>
                </div>
                <Typography color="blue">(*) Mentions obligatoires</Typography>
            </Box>
        </>
    );
}

export default StepProfile;
